import { Component, OnInit, ViewChild } from '@angular/core';
import { LoaderService } from 'src/modules/shared/services/loader.service';
import { ServiceCatalogueService } from 'src/modules/module-service-catalogue/_services/module-service-catalogue-service.service';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-what-we-do',
  templateUrl: './what-we-do.component.html',
  styleUrls: ['./what-we-do.component.scss']
})
export class WhatWeDoComponent implements OnInit {
  @ViewChild('owlElement') owlElement: OwlOptions
  cards = [];
  showComponent: boolean;
  customOptions: OwlOptions;
  ATDModuleId: string = "8ee24a2c-e674-ea11-ab11-000d3a258246";
  ALDModuleId: string = "700e6070-6363-ed11-a8ea-6045bd8abf6c";
  LTRDModuleId: string = 'c401e3bd-c00e-ea11-aa64-000d3a258246';
  PRAModuleId: string = '17f669d0-9d0b-ea11-aa5d-000d3a258246';
  constructor(private service: ServiceCatalogueService) { }
  ngOnInit() {

    this.onGetModules();

    this.customOptions = {
      items: 3,
      loop:false,
      pullDrag: true,
      autoWidth: true,
      navText: ['<span class="icon-icon-nav-left arrow-container"></span>', '<span class="icon-icon-nav-right arrow-container"></span>'],
      rtl: localStorage.getItem('lang') === 'ar' ? true : false,
      margin: 30,
      responsive: {
        0: {
          items: 1,
          dots: true,
          nav: false
        },
        400: {
          items: 2,
          dots: false
        },
        740: {
          items: 3,
          dots: false
        },
        940: {
          items: 3,
          dots: false
        }
      },
      nav: true

    };


  }

  onGetModules() {
    let params = {
        "language": localStorage.getItem('lang') == 'ar' ? localStorage.getItem('lang') + '-SA' : 'en'
    }

    LoaderService.showLoader();
    this.service.GetMTTmodules( params).subscribe(response => {
      // response['Result'].map((item) => item.iconClass = 'icon-truck');
      this.cards = response['Result'];
      this.showComponent = true;
      LoaderService.hideLoader();

    });
  }

}
